<template>
	<b-modal ref="mdlError" id="mdlError" size="md" style="height: 100%" ok-only ok-title="Chiudi" variant="danger" centered title="Attenzione">
		<div class="sa-modal-error">
			<div class="sa-modal-error-message">
				<li v-for="riga in listaErrori" :key="riga" class="event">
					<span class="mdi mdi-circle pal"></span>
					<span class="sa-timeline-date">{{ riga }}</span>
				</li>
			</div>
			<div class="sa-modal-error-icon">
				<i class="fas fa-exclamation-circle"></i>
			</div>
		</div>
		<!-- 
		<template #modal-footer>
			<b-button size="sm" variant="danger" @click="onCloseClick()">OK</b-button>
		</template> -->
	</b-modal>
</template>

<script>
export default {
	data() {
		return {
			listaErrori: [],
		};
	},
	methods: {
		show(errors) {
			if (!errors) {
				errors = "";
			}

			this.listaErrori = errors.split("#");
			this.listaErrori.splice(-1);
			this.$refs.mdlError.show();
		},
		onCloseClick() {
			let me = this;
			me.$refs.mdlError.hide();
		},
	},
};
</script>

<style>
.sa-modal-error {
	padding: 10px;
	display: flex;
	flex-direction: row;
}

.sa-modal-error-icon {
	display: flex;
	flex-direction: row;
	margin: auto;
}
.sa-modal-error-icon svg {
	color: red;
	height: 50px;
	width: 50px !important;
}
</style>
